/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { Table, TableHead, TableRow, TableHeader, TableBody, TableCell } from '@carbon/react';
import useKafkaProperties from 'hooks/kafkaProperties';
import { useTranslation } from 'react-i18next';

function KafkaPropertiesTable({ channelName, operationId, ...other }) {
  const { t } = useTranslation();
  const properties = useKafkaProperties(channelName, operationId);
  const headers = [t('key'), t('value')];

  return (
    <div className="channel__information">
      <h3 className="channel__label">
        {t('properties')}
      </h3>
      <div className="channel__value">
        <Table {...other}>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableHeader key={header}>{header}</TableHeader>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {properties.map((property) => (
              <TableRow tabIndex={0} key={property.key}>
                {Object.keys(property).map((key) => (
                  <TableCell key={key}>{property[key]}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export default KafkaPropertiesTable;
